import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    rePassSuccess(state, codeVerifMatch) {
      state.status = codeVerifMatch;
    },
    rePassError(state) {
      state.status = 'error';
    },
    sendCodeSuccess(state, codeVerifGen) {
      state.status = codeVerifGen;
    },
    sendCodeError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proResPassSchema();
        const schema = res.data;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async rePass({ commit }, payload) {
      try {
        let model = {};
        model = payload.model;
        model.userType = 'Pro';

        const res = await apiClient.usersRePass(model);
        const codeVerifMatch = res.data.data.codeVerifMatch;
        commit('rePassSuccess', codeVerifMatch);
      } catch (e) {
        console.error('Error cuenta');
        commit('passError');
        throw e;
      }
    },
    async reSendCode({ commit }, payload) {
      try {
        const id = getInstProfesId();

        let model = {};
        if (payload === undefined) {
          model.usersCodeVerif = false;
        } else {
          model = payload.model;
          model.id = id;
          model.type = 'Pro';
        }

        const res = await apiClient.usersCodeVerifGen(model);
        const codeVerifGen = res.data.data.codeVerifGen;
        commit('sendCodeSuccess', codeVerifGen);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error reenviando');
        commit('sendCodeError');
        throw error;
      }
    },
    async change({ commit }, model) {
      try {
        model.userType = 'Pro';
        await apiClient.usersRePass(model);
        commit('sendSuccess');
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error reenviando');
        commit('sendError');
        throw error;
      }
    },
  },
};
